exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-content > .main-area.type-dashboard {\n  padding: 16px;\n}\n", ""]);
